var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_c('div',{staticClass:"Footers"},[_c('span',{staticClass:"Footerss"},[_vm._v(" 主管单位：教育部职业教育与成人教育司")]),_c('span',{staticClass:"Footerss"},[_vm._v("技术支持单位：教育部教育管理信息中心")])])])
}]

export { render, staticRenderFns }